import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

const sponsorList = [
    { imgUrl: 'assets/images/sponsor/1.png', imgAlt: 'sponsor 1' },
    { imgUrl: 'assets/images/sponsor/2.png', imgAlt: 'sponsor 2' },
    { imgUrl: 'assets/images/sponsor/3.png', imgAlt: 'sponsor 3' },
    { imgUrl: 'assets/images/sponsor/4.png', imgAlt: 'sponsor 4' },
    { imgUrl: 'assets/images/sponsor/5.png', imgAlt: 'sponsor 5' },
    { imgUrl: 'assets/images/sponsor/6.png', imgAlt: 'sponsor 6' },
    { imgUrl: 'assets/images/sponsor/7.png', imgAlt: 'sponsor 7' },
    { imgUrl: 'assets/images/sponsor/8.png', imgAlt: 'sponsor 8' },
    { imgUrl: 'assets/images/sponsor/9.png', imgAlt: 'sponsor 9' },
    { imgUrl: 'assets/images/sponsor/10.png', imgAlt: 'sponsor 10' },
    { imgUrl: 'assets/images/sponsor/11.png', imgAlt: 'sponsor 11' },
    { imgUrl: 'assets/images/sponsor/12.png', imgAlt: 'sponsor 12' },
    { imgUrl: 'assets/images/sponsor/13.png', imgAlt: 'sponsor 13' },
    { imgUrl: 'assets/images/sponsor/14.png', imgAlt: 'sponsor 14' },
    { imgUrl: 'assets/images/sponsor/15.png', imgAlt: 'sponsor 15' },
    { imgUrl: 'assets/images/sponsor/16.png', imgAlt: 'sponsor 16' },
    { imgUrl: 'assets/images/sponsor/17.png', imgAlt: 'sponsor 17' },
    { imgUrl: 'assets/images/sponsor/18.png', imgAlt: 'sponsor 18' },
    { imgUrl: 'assets/images/sponsor/19.png', imgAlt: 'sponsor 19' },
    { imgUrl: 'assets/images/sponsor/20.png', imgAlt: 'sponsor 20' },
    { imgUrl: 'assets/images/sponsor/21.png', imgAlt: 'sponsor 21' },
    { imgUrl: 'assets/images/sponsor/23.png', imgAlt: 'sponsor 23' },
    { imgUrl: 'assets/images/sponsor/24.png', imgAlt: 'sponsor 24' },
    { imgUrl: 'assets/images/sponsor/25.png', imgAlt: 'sponsor 25' },
    { imgUrl: 'assets/images/sponsor/26.png', imgAlt: 'sponsor 26' },
    { imgUrl: 'assets/images/sponsor/27.png', imgAlt: 'sponsor 27' },
    { imgUrl: 'assets/images/sponsor/28.png', imgAlt: 'sponsor 28' },
    { imgUrl: 'assets/images/sponsor/29.png', imgAlt: 'sponsor 29' },
    { imgUrl: 'assets/images/sponsor/30.png', imgAlt: 'sponsor 30' },
    { imgUrl: 'assets/images/sponsor/31.png', imgAlt: 'sponsor 31' },
    { imgUrl: 'assets/images/sponsor/32.png', imgAlt: 'sponsor 32' },
    { imgUrl: 'assets/images/sponsor/33.png', imgAlt: 'sponsor 33' },
    { imgUrl: 'assets/images/sponsor/34.png', imgAlt: 'sponsor 34' },
    { imgUrl: 'assets/images/sponsor/35.png', imgAlt: 'sponsor 35' },
    { imgUrl: 'assets/images/sponsor/36.png', imgAlt: 'sponsor 36' },
    { imgUrl: 'assets/images/sponsor/37.png', imgAlt: 'sponsor 37' },
    { imgUrl: 'assets/images/sponsor/38.png', imgAlt: 'sponsor 38' },
    { imgUrl: 'assets/images/sponsor/39.png', imgAlt: 'sponsor 39' },
    { imgUrl: 'assets/images/sponsor/40.png', imgAlt: 'sponsor 40' },
    { imgUrl: 'assets/images/sponsor/41.png', imgAlt: 'sponsor 41' },
    { imgUrl: 'assets/images/sponsor/42.png', imgAlt: 'sponsor 42' },
    { imgUrl: 'assets/images/sponsor/43.png', imgAlt: 'sponsor 43' },
    { imgUrl: 'assets/images/sponsor/44.png', imgAlt: 'sponsor 44' },
    { imgUrl: 'assets/images/sponsor/45.png', imgAlt: 'sponsor 45' },
    { imgUrl: 'assets/images/sponsor/46.png', imgAlt: 'sponsor 46' },
    { imgUrl: 'assets/images/sponsor/47.png', imgAlt: 'sponsor 47' },
    { imgUrl: 'assets/images/sponsor/48.png', imgAlt: 'sponsor 48' },
    { imgUrl: 'assets/images/sponsor/49.png', imgAlt: 'sponsor 49' },
    { imgUrl: 'assets/images/sponsor/50.png', imgAlt: 'sponsor 50' },
    { imgUrl: 'assets/images/sponsor/51.png', imgAlt: 'sponsor 51' },
    { imgUrl: 'assets/images/sponsor/52.png', imgAlt: 'sponsor 52' }
];


// Function to split the array into chunks
const chunkArray = (arr, chunkSize) => {
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize));
    }
    return result;
};

// Split sponsors into 3 rows
const sponsorRows = chunkArray(sponsorList, Math.ceil(sponsorList.length / 3));

const Sponsor = () => {
    return (
        <div className="container mt-16">
            <h3 className="text-center">Our Partner Universities</h3>
            <p className="text-center">Partnering with prestigious universities around the world to foster academic excellence, research innovation, and global opportunities for students.</p>
            <div className="sponsor-section section-bg">

                <div className="container">

                    <div className="section-wrapper">
                        {sponsorRows.map((row, index) => (
                            <div className="sponsor-slider" key={index} style={{ marginBottom: "20px" }}>
                                <Swiper
                                    spaceBetween={20}
                                    slidesPerView={5}
                                    loop={true}
                                    autoplay={{
                                        delay: 3000 + index * 1000, // Each row has a slightly different delay
                                        disableOnInteraction: false,
                                    }}
                                    modules={[Autoplay]}
                                    breakpoints={{
                                        0: { slidesPerView: 2 },
                                        768: { slidesPerView: 3 },
                                        1200: { slidesPerView: 5 },
                                    }}
                                >
                                    {row.map((val, i) => (
                                        <SwiperSlide key={i}>
                                            <div className="sponsor-item flex justify-center items-center w-[150px] h-[70px] bg-white box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px; rounded-lg p-2">
                                                <div className="sponsor-thumb w-full h-full flex justify-center items-center">
                                                    <img className="w-full h-full object-contain" src={val.imgUrl} alt={val.imgAlt} />
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}

                                </Swiper>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sponsor;
